module.exports = "data:image/svg+xml;base64,PHN2Zz4KICA8ZGVmcz4KICAgIDwhLS0gVE9ETyB2aWV3Qm94IHByb2JhYmx5IHdyb25nIC0tPgogICAgPHN5bWJvbCBpZD0icGVudGFnb24iIG92ZXJmbG93PSJ2aXNpYmxlIiBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIiB2aWV3Qm94PSIwIDAgMTAwIDEwMCI+Cgk8ZGVzYz5wZW50YWdvbjwvZGVzYz4KCTxwb2x5Z29uIHN0cm9rZT0iY3VycmVudENvbG9yIiBwb2ludHM9IjU5LjE1OTczMjgxODYwMzUxNiw5OS42MTMyMjAyMTQ4NDM3NSA5NSw1MC4yODMzMTc1NjU5MTc5NyA1OS4xNTk3MzI4MTg2MDM1MTYsMC45NTM0MTk2ODUzNjM3Njk1IDEuMTY4OTYyMDAxODAwNTM3LDE5Ljc5NTc2NDkyMzA5NTcwMyAxLjE2ODk2MjAwMTgwMDUzNyw4MC43NzA4NzQwMjM0Mzc1ICIvPgogICAgPC9zeW1ib2w+CiAgPC9kZWZzPgoKPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/icons/pentagon.svg
// module id = 706
// module chunks = 0